<footer class="rackeo-footer-shell">
  <div class="footer-top">
    <div class="container">
      <div class="copyright">
        Copyright © Rackeo | {{ countryName }} | Todos los valores no incluyen IVA ni Impuestos
      </div>
      <div class="partner-box">
        <img class="partner-logo" src="assets/images/rackeo/marca/logo.svg" alt="Logo Rackeo" width="32" height="32" />
        <div class="partner-links">
          <a routerLink="/empresa">Rackeo {{ countryName }}</a>
          <span class="sep">|</span>
          <a routerLink="/hosting-reseller">Reseller Web Hosting</a>
        </div>
      </div>
    </div>
  </div>

  <div class="footer-main">
    <div class="container footer-grid">
      <div class="footer-column">
        <h4 class="column-title">NUESTROS SERVICIOS</h4>
        <ul class="footer-links">
          <li><a routerLink="/web-hosting">Web Hosting</a></li>
          <li><a routerLink="/hosting-reseller">Hosting Reseller</a></li>
          <li><a routerLink="/virtualizacion">VPS</a></li>
          <li><a routerLink="/servidores-dedicados">Servidores Dedicados</a></li>
          <li><a [href]="cart.countryRegisterDomainUrl">Registro de Dominio</a></li>
        </ul>
      </div>
      <div class="footer-column">
        <h4 class="column-title">SOPORTE Y AYUDA</h4>
        <ul class="footer-links">
          <li><a [href]="URL.RACKEO_LOGIN">Área Cliente</a></li>
          <li><a [href]="URL.RACKEO_DOCS" target="_blank" rel="noopener noreferrer">Ayuda y tutoriales</a></li>
          <li><a [href]="URL.RACKEO_YOUTUBE" target="_blank" rel="noopener noreferrer">Videos de Soporte</a></li>
          <li *ngIf="site.isChile"><a routerLink="/paga-deuda">Pago de cuentas</a></li>
          <li><a [href]="URL.RACKEO_INVOICE_REQUEST">Solicitar Factura</a></li>
          <li><a [href]="URL.RACKEO_STATUS" target="_blank" rel="noopener noreferrer">Estado de Servidores</a></li>
        </ul>
      </div>
      <div class="footer-column">
        <h4 class="column-title">EMPRESA</h4>
        <ul class="footer-links">
          <li><a routerLink="/empresa/nosotros">Nosotros</a></li>
          <li><a [href]="URL.HAULMER_BLOG">Blog</a></li>
          <li><a routerLink="/empresa/formas-pago">Formas de Pago</a></li>
          <li><a [href]="URL.HAULMER_LEGAL_WEB_HOSTING">Términos y Condiciones</a></li>
        </ul>
      </div>
    </div>
  </div>

  <div class="footer-accent-bar" aria-hidden="true">
    <span class="accent-seg accent-blue"></span>
    <span class="accent-seg accent-orange"></span>
    <span class="accent-seg accent-green"></span>
    <span class="accent-seg accent-brown"></span>
  </div>
</footer>
